import { Guid } from '@web/utils';

export class AdminOrderInvoice {
  public constructor(
    private readonly data: {
      id: Guid;
      number: string;
      canBeDownloaded: boolean;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get number(): string {
    return this.data.number;
  }

  public get canBeDownloaded(): boolean {
    return this.data.canBeDownloaded;
  }
}
